import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = { class: "nav" }

import { CaretTop } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const blurAgain = (e) => {
  e.target.blur()
}
const toTop = () => {
  document.documentElement.scrollTop = 0
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("a", { href: "/" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                })
              ], -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 3 }),
          _createVNode(_component_el_col, {
            class: "nav-item",
            span: 13
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                mode: "horizontal",
                "text-color": "#333",
                "default-active": _ctx.$route.path,
                "background-color": "#F6F4EE",
                "active-text-color": "#333",
                router: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "/" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Home", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, { index: "/browser" }, {
                    title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("p", { style: {"font-size":"14px"} }, "Browser", -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "/browser/alphabeta" }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("αβ T cell", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/browser/gammadelta" }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("γδ T cell", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/search" }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Search", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/analysis" }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Analysis", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/download" }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode("Download", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/about" }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("About", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["default-active"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_view)
    ]),
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"footer\"><div><p align=\"center\" style=\"margin:5px;\"><strong>©</strong><a href=\"https://zhanglabtju.github.io/index\" target=\"_blank\">Zhang Lab</a>, <a href=\"http://www.tju.edu.cn/\" target=\"_blank\">Tianjin University</a><span>, China</span></p><a class=\"text-color\" href=\"https://beian.miit.gov.cn\" target=\"_blank\">津ICP备2022005007号-1</a><br></div></div>", 1)),
    _createVNode(_component_el_button, {
      class: "top",
      onClick: toTop,
      onFocus: blurAgain,
      circle: "",
      size: "large"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_icon, { size: "large" }, {
          default: _withCtx(() => [
            _createVNode(_unref(CaretTop))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})